import React, { useState } from 'react';
import { api } from '../utils/api';

interface SubmissionFormProps {
  onSubmit: (submission: any) => void;
}

const SubmissionForm: React.FC<SubmissionFormProps> = ({ onSubmit }) => {
  const [link, setLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.submitEntry({ link });
      onSubmit({
        link,
      });
      setLink('');
    } catch (err) {
      setError('Failed to submit entry');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">

      <div>
        <input
          type="url"
          required
          value={link}
          onChange={(e) => setLink(e.target.value)}
          className="w-full px-3 py-2 border border-neutral-300 focus:border-neutral-500 focus:outline-none font-mono text-sm"
          placeholder="https://..."
        />
      </div>

      {error && (
        <div className="p-2 border border-neutral-300 bg-neutral-50 text-xs font-mono text-neutral-700">
          {error}
        </div>
      )}

      <button
        type="submit"
        disabled={loading}
        className="w-full py-2 border border-neutral-900 bg-neutral-900 text-white font-mono text-sm hover:bg-neutral-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        {loading ? 'submitting...' : 'submit'}
      </button>
    </form>
  );
};

export default SubmissionForm;
